import React from 'react';
import { fetchVeImpactAnalytics } from '../../../../Redux/Constants/apiService';
import ImpactAnalyticsEmbed from './ImpactAnalyticsEmbed';

export const VE_IMPACT_EMBED_HEIGHT_MESSAGE = 've-impact-embed-height';

const VeImpactAnalytics = () => (
  <ImpactAnalyticsEmbed
    fetchHtml={fetchVeImpactAnalytics}
    embedHeightMessage={VE_IMPACT_EMBED_HEIGHT_MESSAGE}
    embedStyleId="ve-impact-embed-style"
    embedResizerId="ve-impact-embed-resizer"
    loadingText="Loading VE Activities & Impact Analysis Analytics"
    iframeTitle="VE Activities & Impact Analysis"
    loadErrorFallback="Unable to load VE Activities & Impact Analysis Analytics."
  />
);

export default VeImpactAnalytics;
